
const digest = '933ffbd4dd9b5cce455414e6b266a140fe1916525d16916aa6338d9a46f31e39';
const classes = {"wrapper":"_wrapper_rg6kn_1"};
const css = `._wrapper_rg6kn_1 {
  display: flex;
  flex: 1;
  background-color: #d8eff8;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 0;
  color: #3e3f42;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  